'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  ElectronicsLandingPageEvent,
  ElectronicsLandingPageModel,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import IntroductionSection from './components/IntroductionSection/IntroductionSection'
import WhySection from './components/WhySection/WhySection'
import HowSection from './components/HowSection/HowSection'
import DiscoverSection from './components/DiscoverSection/DiscoverSection'
import BottomSection from './components/BottomSection/BottomSection'
import DisclaimerSection from './components/DisclaimerSection/DisclaimerSection'

type Props = { content: ElectronicsLandingPageModel }

const BuyElectronicsLandingPage = ({ content }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    const trackLandingPageView = async () =>
      track(
        landingPageEvent({
          event: ElectronicsLandingPageEvent.BuyLandingPageView,
          referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
          deviceId: await getFingerprint(),
        }),
      )

    trackLandingPageView()
  }, [track])

  return (
    <div className="electronics__landing-page">
      <div className="electronics__landing-page-container">
        <IntroductionSection content={content.introductionSection} />
        <WhySection content={content.whySection} />
        <HowSection content={content.howSection} />
        <DiscoverSection content={content.discoverSection} />
        <BottomSection content={content.bottomSection} />
        <DisclaimerSection content={content.disclaimerSection} />
      </div>
    </div>
  )
}

export default BuyElectronicsLandingPage
